import React, { HTMLAttributes, KeyboardEvent, useState } from 'react';
import { Button, InputAdornment, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Search } from '@material-ui/icons';
import clsx from 'clsx';

type Props = HTMLAttributes<HTMLDivElement> & {
  filtering: boolean;
  onSearch: (value: string) => void;
  onReset: () => void;
};

const useStyles = makeStyles({
  searchBox: {
    margin: '0px 16px',
  },
  textField: {
    backgroundColor: 'white',
    borderRadius: 4,
    marginRight: 4,
    maxWidth: 600,
    padding: `8px 8px`,
  },
});

const SearchBox: React.FC<Props> = ({
  filtering,
  onSearch,
  onReset,
  ...props
}) => {
  const [keyword, setKeyword] = useState<string>('');
  const { searchBox, textField } = useStyles();

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch(keyword);
    }
  };

  return (
    <form
      className={clsx(props.className, searchBox)}
      action="."
      onSubmit={(e) => e.preventDefault()}
    >
      <InputBase
        className={textField}
        fullWidth
        placeholder="university or program"
        value={keyword}
        type="search"
        startAdornment={
          <InputAdornment position="end">
            <Search style={{ marginRight: 8 }} />
          </InputAdornment>
        }
        onChange={(e) => setKeyword(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <Button
        variant="contained"
        color="secondary"
        disabled={!filtering}
        onClick={() => {
          setKeyword('');
          onReset();
        }}
      >
        Reset
      </Button>
    </form>
  );
};

export default SearchBox;
